import { GroupId } from './GroupId';
import { Fields } from './Fields';
export const groups = (payload) => [
    {
        id: GroupId.AdditionalData,
        description: 'This group will be used by the UI when underwriting identifies that additional data must be collected.',
        labelTitle: 'group.title.additional_data',
        fallbackTitle: 'Additional information',
        labelSubtitle: 'group.subtitle.additional_data',
        fallbackSubtitle: 'We are reviewing your application and need some more information to proceed.',
        fields: {},
        fieldPathsOnPayload: {},
        priority: 1,
    },
    {
        id: GroupId.AdsManagerGetStarted,
        description: 'Ads Manager onboarding getting started page',
        labelTitle: 'group.title.ads_manager_get_started',
        fallbackTitle: 'Almost there.',
        labelSubtitle: 'group.subtitle.ads_manager_get_started',
        fallbackSubtitle: 'Please provide a billing email that campaign invoices will be sent to. You must be an admin user to activate the account. Admin can then grant permissions to other users.',
        fields: {
            billing_email: Fields.billing.billing_email,
        },
        fieldPathsOnPayload: {
            billing_email: 'billing.billing_email',
        },
        priority: 9,
    },
    {
        id: GroupId.BankAccount,
        description: 'Bank account details.',
        labelTitle: 'group.title.bank_account',
        fallbackTitle: 'What are your bank account details?',
        labelSubtitle: 'group.subtitle.bank_account',
        fallbackSubtitle: 'Klarna transactions will be transferred to this bank account.',
        fields: {
            bank_accounts: Fields.bank_accounts,
        },
        fieldPathsOnPayload: {
            bank_accounts: 'bank_accounts',
        },
        priority: 110,
    },
    {
        id: GroupId.BusinessSize,
        description: 'Business size',
        labelTitle: 'group.title.business_size',
        fallbackTitle: 'What is your yearly revenue?',
        labelSubtitle: 'group.subtitle.business_size',
        fallbackSubtitle: 'We need some basic information regarding your business to process your application.',
        fields: {
            business_size: Fields.business_size,
        },
        fieldPathsOnPayload: {
            business_size: 'business_size',
        },
        priority: 40,
    },
    {
        id: GroupId.ContentStoreGetStarted,
        description: 'Content Store onboarding getting started page',
        labelTitle: 'group.title.content_store_get_started',
        fallbackTitle: 'Almost there.',
        labelSubtitle: 'group.subtitle.content_store_get_started',
        fallbackSubtitle: 'Before getting access to Content Manager, please read and accept our Terms and Conditions.',
        fields: {},
        fieldPathsOnPayload: {},
        priority: 8,
    },
    {
        id: GroupId.InStoreGetStarted,
        description: 'Get started',
        labelTitle: 'group.title.in_store_get_started',
        fallbackTitle: 'Get your business started with Klarna.',
        labelSubtitle: 'group.subtitle.in_store_get_started',
        fallbackSubtitle: 'We need some basic information to get you to the right place',
        fields: {
            registration_country: Fields.business_information.registration_country,
        },
        fieldPathsOnPayload: {
            registration_country: 'business_information.registration_country',
        },
        priority: 10,
    },
    {
        id: GroupId.InStoreLegalForm,
        description: 'Business legal entity details',
        labelTitle: 'group.title.in_store_legal_form',
        fallbackTitle: 'What type of business do you have?',
        labelSubtitle: 'group.subtitle.in_store_legal_form',
        fallbackSubtitle: 'We are required to ask some specific questions based on your business type.',
        fields: {
            legal_form: Fields.business_information.legal_form,
        },
        fieldPathsOnPayload: {
            legal_form: 'business_information.legal_form',
        },
        priority: 80,
    },
    {
        id: GroupId.InStoreRegisteredAddress,
        description: 'In store address registered address.',
        labelTitle: 'group.title.in_store_registered_address',
        fallbackTitle: 'What are your registered address?',
        labelSubtitle: 'group.subtitle.in_store_registered_address',
        fallbackSubtitle: 'This is where your business is legally registered, and will appear in your klarna customer invoices.',
        fields: {
            company_name: Fields.business_information.company_name,
            registered_address: Fields.business_information.registered_address,
        },
        fieldPathsOnPayload: {
            company_name: 'business_information.company_name',
            registered_address: 'business_information.registered_address',
        },
        priority: 90,
    },
    {
        id: GroupId.InStoreRegistration,
        description: 'Registration details',
        labelTitle: 'group.title.in_store_registration',
        fallbackTitle: 'Is your business a registered company?',
        labelSubtitle: 'group.subtitle.in_store_registration',
        fallbackSubtitle: 'We need your company registration number to verify your business details.',
        fields: {
            is_registered: Fields.business_information.is_registered,
            registration_authority: Fields.business_information.registration_authority,
            registration_id: Fields.business_information.registration_id,
        },
        fieldPathsOnPayload: {
            is_registered: 'business_information.is_registered',
            registration_authority: 'business_information.registration_authority',
            registration_id: 'business_information.registration_id',
        },
        priority: 60,
    },
    {
        id: GroupId.InStoreStakeholder,
        description: 'In store owner.',
        labelTitle: 'group.title.in_store_stakeholder',
        fallbackTitle: 'Who manages the company?',
        labelSubtitle: 'group.subtitle.in_store_stakeholder',
        fallbackSubtitle: 'As financial institution, we are required to collect this information',
        fields: {
            persons: Fields.business_information.persons,
        },
        fieldPathsOnPayload: {
            persons: 'business_information.persons',
        },
        priority: 100,
    },
    {
        id: GroupId.InStoreStores,
        description: 'Initial business information for in-store',
        labelTitle: 'group.title.in_store_stores',
        fallbackTitle: 'What are your store details?',
        labelSubtitle: 'group.subtitle.in_store_stores',
        fallbackSubtitle: 'We\'ll use the information to set up your account.',
        fields: {
            in_stores: Fields.in_stores,
        },
        fieldPathsOnPayload: {
            in_stores: 'in_stores',
        },
        priority: 30,
    },
    {
        id: GroupId.InStoreVat,
        description: 'VAT registration details',
        labelTitle: 'group.title.in_store_vat',
        fallbackTitle: 'Is your business registered for VAT?',
        labelSubtitle: 'group.subtitle.in_store_vat',
        fallbackSubtitle: 'If you have a VAT number, we can more easily verify your company details.',
        fields: {
            subject_to_vat: Fields.business_information.subject_to_vat,
            vat_id: Fields.business_information.vat_id,
        },
        fieldPathsOnPayload: {
            subject_to_vat: 'business_information.subject_to_vat',
            vat_id: 'business_information.vat_id',
        },
        priority: 70,
    },
    {
        id: GroupId.ProductChannel,
        description: 'Details about how sales are done',
        labelTitle: 'group.title.product_channel',
        fallbackTitle: 'How do you plan to do your sales?',
        labelSubtitle: 'group.subtitle.product_channel',
        fallbackSubtitle: 'We will use this information to set up your account.',
        fields: {
            product_channel: Fields.business_information.product_channel,
            should_auto_capture_orders: Fields.business_information.should_auto_capture_orders,
        },
        fieldPathsOnPayload: {
            product_channel: 'business_information.product_channel',
            should_auto_capture_orders: 'business_information.should_auto_capture_orders',
        },
        priority: 20,
    },
    {
        id: GroupId.SensitiveGoods,
        description: 'Sensitive goods',
        labelTitle: 'group.title.sensitive_goods',
        fallbackTitle: 'Do you offer any of the following products or services at your physical store?',
        labelSubtitle: 'group.subtitle.sensitive_goods',
        fallbackSubtitle: 'Klarna might define some items as restricted based on market, laws, sales volume, risk appetite, and other limitations that can be allowed and shall not be processed without Klarna\'s approval.',
        fields: {
            sensitive_goods: Fields.sensitive_goods,
        },
        fieldPathsOnPayload: {
            sensitive_goods: 'sensitive_goods',
        },
        priority: 50,
    },
];
